import Vue from 'vue'

const state = {
    defaultOrigin:{
        name: ''
    },
    origins: null,
    selectedOrigin: null,
};

const getters = {
    getOrigins: (state, rootstate) => {
        if(!state.origins || state.origins.length == 0) return []
        return state.origins
    },
    getDefaultOrigin: (state) => state.defaultOrigin,
    getSelectedOrigin: (state) => state.selectedOrigin,
};

const actions = {
    downloadOrigins ({state, rootState, commit}){
        if(!rootState.user.account.supplierId){
            return false
        }

        return axios.get('/api/Supplier/GetOrigins', {
            params: {
                supplierId: rootState.user.account.supplierId
            }
        }).then(response => {
            if(response.status == 200){

                var output = response.data

                commit('SET_ORIGINS', output)
            }
        })


    },
    setSelectedOrigin ({ state }, payload) {
        state.selectedOrigin = payload
    },

    createOrigin ({ state, rootState, commit }, payload) {
        return axios.post('/api/Supplier/CreateOrigin', {
            supplierId: rootState.user.account.supplierId,
            origin: payload
        }).then(response => {
            if(response.status == 200){
                commit('ADD_ORIGIN', response.data)
            }
        })
    },

    updateOrigin ({ state, rootState, commit }, payload) {
        return axios.post('/api/Supplier/EditOrigin', {
            supplierId: rootState.user.account.supplierId,
            origin: payload
        }).then(response => {
            if(response.status == 200){
                commit('UPDATE_ORIGIN', response.data)
                return true
            }
            return false
        })
    },

    deleteOrigin ({ state, rootState, commit }, payload) {
        return axios.post('/api/Supplier/DeleteOrigin', {
            supplierId: rootState.user.account.supplierId,
            origin: payload
        }).then(response => {
            if(response.status == 200){
                if(response.data == true){
                    commit('REMOVE_ORIGIN', payload)
                }
            }
        })
    },
};

const mutations = {
    SET_ORIGINS: (state, payload) => {
        state.origins = payload;
    },

    ADD_ORIGIN: (state, payload) => {
        state.origins.push(payload)
    },

    REMOVE_ORIGIN: (state, payload) => {
        let index = state.origins.indexOf(payload)
        state.origins.splice(index, 1)
    },
	UPDATE_ORIGIN: (state, payload) => {
		const index = state.origins.indexOf(payload);
		const updatedOrigins = [...state.origins]; // Create a copy of the origins array
		updatedOrigins.splice(index, 1, payload); // Replace the origin at the found index with the new payload

		// Return a new state object with the updated origins array
		return {
			...state,
			origins: updatedOrigins
		};
	}


};

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/origins.js